import React, { useEffect } from 'react';
import { Table } from 'antd';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { selectFilteredParts, selectPartLoading, selectfetchPartLoading } from './store/selectors';
import { showModal } from 'Core/redux/main/slice';
import { deletePart } from './store/slice';
import { MODAL_TYPES } from 'Feature/components/app-modals';
import LoadingSpinner from '../../InitialPage/Sidebar/LoadingSpinner';
import { actions as partActions, getPartDetailsById } from './store/slice';

const { setProduct } = partActions;

const { PARTS_ADD_EDIT } = MODAL_TYPES;

const PartTable = () => {
  const dispatch = useDispatch();
  const { filteredData, isLoading } = useSelector(state => ({
    filteredData: selectFilteredParts(state),
    isLoading: selectPartLoading(state) || selectfetchPartLoading(state),
  }));

  const handleEditClick = record => {
    dispatch(getPartDetailsById(record.id));
  };

  const handleDeleteClick = id => {
    dispatch(deletePart(id));
  };

  const handleCheckboxChange = (e, record) => {
    // Handle checkbox change logic here
    console.log('Checkbox changed', record, e.target.checked);
  };

  const columns = [
    {
      title: 'Description',
      dataIndex: 'description',
      sorter: (a, b) => a.description.length - b.description.length,
    },
    {
      title: 'Part Number',
      dataIndex: 'partNumber',
      sorter: (a, b) => a.partNumber.length - b.partNumber.length,
    },
    // {
    //   title: 'ID',
    //   dataIndex: 'id',
    //   sorter: (a, b) => a.id.length - b.id.length,
    // },
    {
      title: 'Actions',
      dataIndex: 'id',
      key: 'id',
      render: (text, record) => (
        <div className="action-table-data">
          <div className="edit-delete-action justify-content-start">
            <Link className="me-2 p-2" onClick={() => handleEditClick(record)}>
              <i data-feather="edit" className="feather-edit"></i>
            </Link>
            {/* <Link className="confirm-text p-2" onClick={() => handleDeleteClick(record.id)}>
              <i data-feather="trash-2" className="feather-trash-2"></i>
            </Link> */}
          </div>
        </div>
      ),
    },
  ];

  return (
    <div className="table-responsive product-list">
      {isLoading && <LoadingSpinner />}
      <Table columns={columns} dataSource={filteredData} />
    </div>
  );
};

export default PartTable;
